import React from "react";

const ImageIcon = ({ ...props }) => {
  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        opacity="0.3"
        x="1.83337"
        y="3.66602"
        width="18.3333"
        height="14.6667"
        rx="2"
        fill="#696D8C"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58337 15.5833C5.75933 15.5833 5.28895 14.6426 5.78337 13.9833L9.28337 9.31667C9.68337 8.78333 10.4834 8.78333 10.8834 9.31667L14.3834 13.9833C14.8778 14.6426 14.4074 15.5833 13.5834 15.5833H6.58337Z"
        fill="#696D8C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.164 15.5833C11.3255 15.5833 10.8593 14.6134 11.3831 13.9586L12.9692 11.9761C13.3695 11.4757 14.1306 11.4757 14.5309 11.9761L16.117 13.9586C16.6408 14.6134 16.1746 15.5833 15.3361 15.5833H12.164Z"
        fill="#696D8C"
      />
      <circle opacity="0.3" cx="15.125" cy="8.70898" r="1.375" fill="#696D8C" />
    </svg>
  );
};

export default ImageIcon;
